import { render } from "./Checks.vue?vue&type=template&id=69e89bef&scoped=true"
import script from "./Checks.vue?vue&type=script&lang=js"
export * from "./Checks.vue?vue&type=script&lang=js"

import "./Checks.vue?vue&type=style&index=0&id=69e89bef&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e89bef"]])

export default __exports__